<template>

    <div style="margin-top: 120px">
        <h1 style="text-align: center;line-height: 60px" >粉末填料选择</h1>
        <!--        粉末填料页面一-->
        <el-form ref="form" :model="form"
 :rules="rules">
            <div v-if="fmpage1">
                <el-form-item label="模具类别">
                    <el-select v-model="form.modeltype" placeholder="请选择模具类别">
                        <el-option label="上-下-3件" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <!--              摩擦系数开始-->

                <el-form-item label="摩擦系数">
                    <el-select v-model="form.friction" placeholder="请选择模具类别">
                        <el-option label="硬质合金" :value="0"></el-option>
                        <el-option label="钢模" :value="1"></el-option>
                        <el-option label="自定义" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-row v-if="moca">
                    <el-col :span="12" >
                        <el-form-item label="摩擦系数" prop="frictionval">
                            <el-input  type="number"  v-model="form.frictionval" placeholder="请输入摩擦系数"  />
                        </el-form-item>
                    </el-col>
                </el-row>
                <!--              摩擦系数结束-->
                <!--              粉末间摩擦系数结束-->
                <div class="max">
                    <el-form-item label="粉末间摩擦系数">
                        <el-select v-model="form.powder" placeholder="请选择模具类别">
                            <el-option label="不考虑" :value="1"></el-option>
                            <el-option label="定值(0.22)" :value="2"></el-option>
                            <el-option label="函数" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <el-row v-if="fmmoca">

                    <el-col :span="24"  style="margin-bottom: 20px">  <h3 style="text-align: center">摩擦力=M0*exp(-a)</h3></el-col>


                    <el-col :span="12" >
                        <div class="max">
                            <el-form-item label="压力摩擦因子m0" prop="factorM0">
                                <el-input  type="number"  v-model="form.factorM0" placeholder="请输入压力摩擦因子"  />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="12" >
                        <div class="max">
                            <el-form-item label="压力摩擦因子a" prop="factora">
                                <el-input  type="number"  v-model="form.factora" placeholder="请输入压力摩擦因子"  />
                            </el-form-item>
                        </div>
                    </el-col>



                    <el-col :span="12" >
                        <el-form-item label="温度" prop="temperature">
                            <el-input  type="number"  v-model="form.temperature" placeholder="请输入温度"  />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" >
                        <div class="block" style="line-height: 42px;margin-bottom: 10px">
                            <el-row>
                                <el-col :span="3" style="text-align: left;">

                                    <div class="max">
                                        <el-form-item label="网格精密度" prop="pulsewidth">
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="3" ><span class="demonstration">粗略(40000)</span></el-col>
                                <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" ><el-slider v-model="form.gridding" :min="40000" :max="80000" step="5000"></el-slider></el-col>
                                <el-col :span="3" style="text-align: right;"><span class="demonstration">精细(80000)</span></el-col>
                            </el-row>

                        </div>
                    </el-col>
                    <el-form-item label="选择材料">
                        <el-select placeholder="请选择材料" v-model="form.selectmaterial">
                            <el-option label="0" :value="0"></el-option>
                            <el-option label="1" :value="1"></el-option>
                            <el-option label="2" :value="2"></el-option>
                            <el-option label="3" :value="3"></el-option>
                            <el-option label="4" :value="4"></el-option>
                            <el-option label="5" :value="5"></el-option>
                            <el-option label="6" :value="6"></el-option>

                        </el-select>
                    </el-form-item>



                </el-row>
                <div class="max">
                    <el-form-item label="最大压实密度" >
                        <el-select placeholder="请选择最大压实密度" v-model="form.maxdensity">
                            <el-option label="默认" :value="0"></el-option>
                            <el-option label="自定义" :value="1"></el-option>

                        </el-select>
                    </el-form-item>
                    <el-row>

                        <el-col :span="12" v-if="maxdensity">
                            <h4 style="line-height: 42px">最大压实密度/松装密度>=装料(F尺寸)/压缩后磁芯尺寸(F尺寸)</h4>
                            <el-form-item label="最大压实密度" prop="maxdensityval">
                                <el-input  type="number"  placeholder="请输入最大压实密度" v-model="form.maxdensityval" model-value="3.2" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>

                <el-row style="margin-bottom: 50px">
                    <el-col :span="24" style="text-align: center">
                        <el-button type="primary" @click="fmpage1=false,fmpage2=true">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
                    </el-col>
                </el-row>
            </div>

            <!--            第二个-->
            <div v-if="fmpage2">
                <el-row :gutter="20">
                    <el-col :span="2" style="text-align: right">压机类别</el-col>
                    <el-col :span="7" style="text-align: center" >
                        <img src="../../assets/zlyj.jpg" @click="zlyj=true,xzyj=false,yyj=false,form.presstype=1" :class="{'active':zlyj}" ></el-col>
                    <el-col :span="7" style="text-align: center">
                        <img src="../../assets/xzyj.png" @click="zlyj=false,xzyj=true,yyj=false,form.presstype=2" :class="{'active':xzyj}" ></el-col>
                    <el-col :span="7" style="text-align: center">
                        <img src="../../assets/yyj.jpg" @click="zlyj=false,xzyj=false,yyj=true,form.presstype=3" :class="{'active':yyj}"  ></el-col>
                </el-row>
                <div >
                    <div v-if="zlyj">
                        <h2 style="text-align: center;line-height: 42px;padding: 10px">直立压机</h2>
                        <el-row>
                            <el-col><h3 style="line-height: 42px">第一动作：</h3></el-col>
                            <el-col :span="12">
                                <el-form-item label="速度" prop="datafour">
                                    <el-input  type="number" v-model="form.datafour" placeholder="请输入速度(单位:mm/s)" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <div class="max">
                                    <el-form-item label="上模下压行程" prop="dataone">
                                        <el-input  type="number" v-model="form.dataone" placeholder="请输入上模下压行程(单位:mm)" />
                                    </el-form-item>
                                </div>
                            </el-col>

                            <el-col><h3 style="line-height: 42px">第二动作：</h3></el-col>
                            <el-col :span="12">
                                <div class="max">
                                    <el-form-item label="上模和中模同时下压行程" prop="datatwo">
                                        <el-input  type="number" v-model="form.datatwo" placeholder="请输入上模和中模同时下压行程(单位:mm)" />
                                    </el-form-item>
                                </div>
                            </el-col>


                            <el-col><h3 style="line-height: 42px">第三动作：</h3></el-col>
                            <el-col :span="12">
                                <div class="max">
                                    <el-form-item label="中模停止上模下压行程" prop="datathree">
                                        <el-input  type="number" v-model="form.datathree" placeholder="中模停止,请输入上模下压行程(单位:mm)" />
                                    </el-form-item>
                                </div>
                            </el-col>

                        </el-row>
                    </div>
                    <div v-if="xzyj">
                        <h2 style="text-align: center;line-height: 42px;padding: 10px">旋转压机</h2>
                        <el-row>
                            <el-col><h3 style="line-height: 42px">第一动作：</h3></el-col>
                            <el-col :span="12">
                                <div class="max">
                                    <el-form-item label="上模下压行程" prop="dataone">
                                        <el-input  type="number" v-model="form.dataone" placeholder="请输入上模下压行程(单位:mm)" />
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="上模速度" prop="datatwo">
                                    <el-input  type="number" v-model="form.datatwo" placeholder="请输入上模下压速度(单位:mm/s)" />
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <div class="max">
                                    <el-form-item label="下模上压行程" prop="datathree">
                                        <el-input  type="number" v-model="form.datathree" placeholder="请输入下模上压行程(单位:mm)" />
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="max">
                                    <el-form-item label="下模上压速度" prop="datafour">
                                        <el-input  type="number" v-model="form.datafour" placeholder="请输入下模上压速度(单位:mm/s)" />
                                    </el-form-item>
                                </div>
                            </el-col>
                            <!--旋转压机第二动作-->
                            <el-col><h3 style="line-height: 42px">第二动作：</h3></el-col>
                            <el-col :span="12">
                                <div class="max">
                                    <el-form-item label="上模下压行程" prop="datafive">
                                        <el-input  type="number" v-model.number="form.datafive" placeholder="请输入上模下压行程(单位:mm)" />
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="上模速度" prop="datasix">
                                    <el-input  type="number" v-model.number="form.datasix" placeholder="请输入上模下压速度(单位:mm/s)" />
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <div class="max">
                                    <el-form-item label="下模上压行程" prop="dataseven">
                                        <el-input  type="number" v-model.number="form.dataseven" placeholder="请输入下模上压行程(单位:mm)" />
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="max">
                                    <el-form-item label="下模上压速度" prop="dataeight">
                                        <el-input  type="number" v-model.number="form.dataeight" placeholder="请输入下模上压速度(单位:mm/s)" />
                                    </el-form-item>
                                </div>
                            </el-col>

                        </el-row>

                    </div>
                    <div v-if="yyj">
                        <h2 style="text-align: center;line-height: 42px;padding: 10px">油压机</h2>
                        <el-row>
                            <el-col><h3 style="line-height: 42px">第一动作：</h3></el-col>
                            <el-col :span="12">
                                <div class="max">
                                    <el-form-item label="上模下压行程" prop="dataone">
                                        <el-input  type="number" v-model.number="form.dataone" placeholder="请输入上模下压行程(单位:mm)" />
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="max">
                                    <el-form-item label="上模下压速度" prop="datatwo">
                                        <el-input  type="number" v-model.number="form.datatwo" placeholder="请输入上模下压速度(单位:mm/s)" />
                                    </el-form-item>
                                </div>
                            </el-col>

                            <el-col><h3 style="line-height: 42px">第二动作：</h3></el-col>
                            <el-col :span="12">
                                <div class="max">
                                    <el-form-item label="上模下压行程" prop="datathree">
                                        <el-input  type="number" v-model.number="form.datathree" placeholder="请输入上模下压行程(单位:mm)" />
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="max">
                                    <el-form-item label="凹模下压行程" prop="datafive">
                                        <el-input  type="number" v-model.number="form.datafive" placeholder="请输入凹模下压行程(单位:mm)" />
                                    </el-form-item>
                                </div>
                            </el-col>

                            <el-col><h3 style="line-height: 42px">第三动作：</h3></el-col>
                            <el-col :span="12">
                                <div class="max">
                                    <el-form-item label="上模下压行程" prop="dataseven">
                                        <el-input  type="number" v-model.number="form.dataseven" placeholder="请输入上模下压行程(单位:mm)" />
                                    </el-form-item>
                                </div>
                            </el-col>

                        </el-row>
                    </div>

                </div>
                <el-row style="margin-bottom: 50px">
                    <el-col :span="24" style="text-align: center">
                        <el-button type="primary" @click="fmpage1=true,fmpage2=false"><i class="el-icon-arrow-left el-icon--left"></i>上一页</el-button>

                        <el-button type="primary" @click="fmpage2=false,fmpage3=true">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
                    </el-col>
                </el-row>

            </div>

            <!--         第三个页面-->
            <div v-if="fmpage3">
                <h2 style="text-align: center;height: 42px;padding-bottom: 10px">获取指定密度区间图片</h2>
                <el-row >
                    <el-col :span="12">
                        <div class="max">
                            <el-form-item label="图片1最小密度" prop="piconemin">
                                <el-input  type="number"  v-model.number="form.piconemin" placeholder="请输入图片1最小密度" />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="max">
                            <el-form-item label="图片1最大密度" prop="piconemax">
                                <el-input  type="number"  v-model.number="form.piconemax" placeholder="请输入图片1最大密度" />
                            </el-form-item>
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div class="max">
                            <el-form-item label="图片2最小密度" prop="pictwomin">
                                <el-input  type="number"  v-model.number="form.pictwomin" placeholder="请输入图片2最小密度" />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="max">
                            <el-form-item label="图片2最大密度" prop="pictwomax">
                                <el-input  type="number"  v-model.number="form.pictwomax" placeholder="请输入图片2最大密度" />
                            </el-form-item>
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div class="max">
                            <el-form-item label="图片3最小密度" prop="picthreemin">
                                <el-input  type="number"  v-model.number="form.picthreemin" placeholder="请输入图片2最小密度" />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="max">
                            <el-form-item label="图片3最大密度" prop="picthreemax">
                                <el-input  type="number"  v-model.number="form.picthreemax" placeholder="请输入图片1最大密度" />
                            </el-form-item>
                        </div>
                    </el-col>



                    <el-col :span="12">
                        <div class="max">
                            <el-form-item label="图片4最小密度" prop="picfourmin">
                                <el-input  type="number"  v-model.number="form.picfourmin" placeholder="请输入图片4最小密度" />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="max" style="margin-bottom: 20px">
                            <el-form-item label="图片4最大密度" prop="picfourmax">
                                <el-input  type="number"  v-model.number="form.picfourmax" placeholder="请输入图片4最大密度" />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col>
                        <div class="max">
                            <el-form-item label="是否需要压缩动画" >
                                <el-select placeholder="" v-model="form.animation">
                                    <el-option label="否" :value="2"></el-option>
                                    <el-option label="是" :value="1"></el-option>

                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <div style="padding-top: 20px">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="产品名" prop="product">
                                <el-input v-model.trim="form.product" placeholder="请输入产品名" />
                            </el-form-item>
                        </el-col>


                        <el-col :span="12">
                            <el-form-item label="公司名称" prop="company">
                                <el-input   v-model.trim="form.company" placeholder="请输入公司名称" />
                            </el-form-item>
                        </el-col>


                        <el-col :span="12">
                            <el-form-item label="接收图纸邮箱" prop="email">
                                <el-input  v-model.trim="form.email" placeholder="请输入接收图纸邮箱" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <el-row style="margin:50px 0">
                    <el-col :span="24" style="text-align: center">
                        <el-button type="primary" @click="fmpage3=false,fmpage2=true"><i class="el-icon-arrow-left el-icon--left"></i>上一页</el-button>
                        <el-button type="primary" @click="upload" :loading=loading>提交数据</el-button>
                    </el-col>
                </el-row>



            </div>

        </el-form>

    </div>

</template>

<script>
    import request from "@/utils/request";
    export default {
        name: 'Ifcoresyapi',
        props:['formToIfcoresyapi'],
        data () {
            var check=(rule, value, callback) =>{
                if (value) {
                    let tip = "";
                    if (value* 1<=0){
                        tip = "值必须大于0"
                    }

                    if (tip) {
                        callback(new Error(tip));
                    } else {
                        callback();
                    }
                } else {

                    let tip = "";

                    if (value * 1 === 0||value * 1<0) {
                        tip = "值必须大于0"
                    }else{

                    }

                    if (tip) {
                        callback(new Error(tip));
                    } else {
                        callback();
                    }
                }

            }
            var check2=(rule, value, callback) =>{
                if (value) {
                    let tip = "";
                    if (value* 1<0){
                        tip = "值必须大于等于0"
                    }

                    if (tip) {
                        callback(new Error(tip));
                    } else {
                        callback();
                    }
                }

            }
            return {
                fmpage1:true,
                moca:false,//自定义摩擦系数界面的v-if
                fmmoca:false,//自定义粉末间摩擦系数界面的v-if
                maxdensity:false,//自定义最大压实密度的v-if
                fmpage2:false,
                zlyj:true,
                xzyj:false,
                yyj:false,
                loading:false,
                form:{
                    modeltype:0,//模具类别
                    friction:0,//摩擦系数选择
                    powder:1,//粉末间摩擦系数选择
                    gridding:40000,//网格数初始值
                    selectmaterial:0,//材料选择
                    maxdensity:0,//最大压实密度
                    animation:2,//是否需要压缩动画
                    fianlval:0.22,
                    presstype:1,
                    maxdensityval:3.2
                },
                rules:{
                    frictionval:[{required: true, message: '摩擦系数是必须数据,如果系数不存在,选择\'硬质合金\'或者\'钢模\'', trigger: 'blur'},{validator: check,trigger: 'blur'}],
                    factorM0:[{required: true, message: '压力摩擦因子m0是必须数据,如果系数不存在,选择\'不考虑\'或者\'定值\'', trigger: 'blur'},{validator: check,trigger: 'blur'}],
                    factora:[{required: true, message: '压力摩擦因子a是必须数据,如果系数不存在,选择\'不考虑\'或者\'定值\'', trigger: 'blur'},{validator: check,trigger: 'blur'}],
                    temperature:[{required: true, message: '温度系数是必须数据', trigger: 'blur'}],
                    maxdensityval:[{required: true, message: '最大压实密度是必须数据', trigger: 'blur'}],
                    dataone:[{required: true, message: '必须数据', trigger: 'blur'},{validator: check,trigger: 'blur'}],
                    datatwo:[{required: true, message: '必须数据', trigger: 'blur'},{validator: check,trigger: 'blur'}],
                    datathree:[{required: true, message: '必须数据', trigger: 'blur'},{validator: check,trigger: 'blur'}],
                    datafour:[{required: true, message: '必须数据', trigger: 'blur'},{validator: check,trigger: 'blur'}],
                    datafive:[{required: true, message: '必须数据', trigger: 'blur'},{validator: check,trigger: 'blur'}],
                    datasix:[{required: true, message: '必须数据', trigger: 'blur'},{validator: check,trigger: 'blur'}],
                    dataseven:[{required: true, message: '必须数据', trigger: 'blur'},{validator: check,trigger: 'blur'}],
                    dataeight:[{required: true, message: '必须数据', trigger: 'blur'},{validator: check,trigger: 'blur'}],
                    piconemin:[{required: true, message: '图片1最小密度必须数据', trigger: 'blur'},{validator: check,trigger: 'blur'}],
                    piconemax:[{required: true, message: '图片1最大密度必须数据', trigger: 'blur'},{validator: check,trigger: 'blur'}],
                    pictwomin:[{required: true, message: '图片2最小密度必须数据', trigger: 'blur'},{validator: check,trigger: 'blur'}],
                    pictwomax:[{required: true, message: '图片2最大密度', trigger: 'blur'},{validator: check,trigger: 'blur'}],
                    picthreemin:[{required: true, message: '图片3最小密度', trigger: 'blur'},{validator: check,trigger: 'blur'}],
                    picthreemax:[{required: true, message: '图片3最大密度', trigger: 'blur'},{validator: check,trigger: 'blur'}],
                    picfourmin:[{required: true, message: '图片4最小密度', trigger: 'blur'},{validator: check,trigger: 'blur'}],
                    picfourmax:[{required: true, message: '图片4最大密度', trigger: 'blur'},{validator: check,trigger: 'blur'}],
                    product:[{required: true, message: '产品名是必须数据', trigger: 'blur'},{min:0,max:10,message:"请输入产品名",trigger: 'blur'}],
                    company:[{required: true, message: '公司名是必须数据', trigger: 'blur'},{min:0,max:10,message:"请输入公司名",trigger: 'blur'}],
                    email:[{required: true, message: '接收图纸邮箱是必须数据', trigger: 'blur'},{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}]
                }



            }
        },
        created() {


            this.form={...this.formToYapi,...this.form}



        },
        methods: {
            upload(){
                let forms={...this.formToIfcoresyapi,...this.form}
                this.$refs['form'].validate((valid) => {
                    if (valid){
                        this.loading=true
                        request.post("/list/addYapi",forms).then(res =>{


                            if (res.code=='0'){
                                this.loading=false
                                this.$message({
                                    type:"success",
                                    message:"新增成功"
                                })

                                // this.load() //刷新表格
                                // this.dialogVisible=false //关闭弹窗
                            }else{
                                this.loading=false
                                this.$message({
                                    type:"error",
                                    message:res.msg
                                })
                            }

                        })

                    }else{
                    }
                })


            }
        },
        watch:{
            form:{//深度监听，可监听到对象、数组的变化
                handler(val){
                    if(val.friction!=2){
                        this.moca=false
                    }else{
                        this.moca=true
                    }

                    if(val.powder!=3){
                        this.fmmoca=false

                    }else{
                        this.fmmoca=true

                    }
                    if(val.maxdensity==0){
                        this.maxdensity=false
                    }else{
                        this.maxdensity=true
                    }
                },
                deep:true //true 深度监听
            }


        }


    }
</script>


<style lang="less" scoped>
    i:hover{
        cursor: pointer;
        color: #db261d;
    }
    .border{

        margin-top: 60px;
        height: calc(100vh - 120px);
    }

    .el-input{
        width: 90%;
    }
    div::-webkit-scrollbar {
        display: none;
    }
    /deep/
    input::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
    }

    .max .el-form-item__label{
        line-height: 20px !important;
    }
    .carousel{

        margin-top: 20vh;
        text-align: center;
        img{
            height: 100%;
        }
    }

    @media screen and (max-width:768px){
        .carousel{

            margin: 0;
            padding: 0;

        }
    }
    img:hover{
        cursor: pointer;
    }
    img{
        height: 200px;width: 200px;border: 1px solid #ccc
    }
    .active{
        border: 1px solid orange !important;
    }
</style>

